import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavbarService } from '../navbar/navbar.service';
import { SpinnerService } from '../../services/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { featureFlag } from 'src/environments/environment';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  private s11role: string[] = ['dealer', 'checker', 's11 controller'];
  private returnUrl: string;
  constructor(
    private navbarService: NavbarService,
    private router: Router,
    private spinner: SpinnerService,
    private store: Store,
    private activated: ActivatedRoute,
  ) {}
  ngOnDestroy(): void {
    this.spinner.hide();
  }

  ngOnInit(): void {
    this.spinner.show();
    this.navbarService.setActiveSidebar(false);
    this.returnUrl =
      this.activated.snapshot.queryParams?.['returnUrl']?.split(
        '?',
      )[0];
    this.store
      .select((state) => state.auth.role)
      .pipe(
        filter((role) => !!role),
        take(1),
      )
      .subscribe((role) => {
        this.handleRedirect(role);
      });
  }

  private handleRedirect(role: string): void {
    if (this.returnUrl && this.returnUrl.includes('s11-documents')) {
      this.router.navigate([this.returnUrl]);
    } else {
      if (
        [
          'general',
          'admin',
          's11 commander',
          ...this.s11role,
        ].includes(role.toLowerCase()) &&
        featureFlag.memo_enable
      ) {
        this.router.navigate(['/memos']);
      } else if (
        ['contract management', ...this.s11role].includes(
          role.toLowerCase(),
        ) &&
        featureFlag.econtract_enable
      ) {
        this.router.navigate(['/contract']);
      } else {
        this.router.navigate(['/users']);
      }
    }
    this.navbarService.setActiveSidebar(true);
  }
}
